import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UslugaTableComponent } from './usluga-table/usluga-table.component';

const routes: Routes = [
  {
    path: '',
    component: UslugaTableComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class UslugaRoutingModule {}
